<template>
  <Pager/>
  <div class="results">
    <div
      v-for="result in dataStore?.data?.data"
      :key="result.semnr"
      v-if="dataStore?.data?.num_items"
    >
      <Result :result="result" />
    </div>
    <h5 v-if="dataStore?.data?.num_items === 0">Keine Ergebnisse gefunden</h5>
  </div>
  <Pager/>
</template>

<script setup>
import { useDataStore } from "@/store/";
import Result from "@/components/Veranstaltungen/Result";
import Pager from "@/components/Pager";


const dataStore = useDataStore();
</script>
